// import i18n from '@/plugins/i18n'

export default [
  {
    portalGroup: 'all.public',
    path: 'E0001DemoPost/list',
    name: 'PgList',
    component: () => import('./PgList'),
    meta: { debug: true }
  },
  {
    portalGroup: 'all.admin',
    path: 'E0001DemoPost/view/:id',
    name: 'PgView',
    component: () => import('./PgView'),
    meta: { debug: true }
  },
  {
    portalGroup: 'all.admin',
    path: 'E0001DemoPost/form/:id?',
    name: 'PgForm',
    component: () => import('./PgForm'),
    meta: { debug: true }
  },
  {
    portalGroup: 'all.admin',
    path: 'E0001DemoPost/index',
    name: 'PgMultiPage',
    component: () => import('./PgMultiPage'),
    meta: { debug: true }
  },
  {
    portalGroup: 'all.admin',
    path: 'E0001DemoPost/single',
    name: 'PgSinglePage',
    component: () => import('./PgSinglePage'),
    meta: { debug: true }
  },
  {
    portalGroup: 'press.public',
    path: 'E0001DemoPost/dataImport',
    name: 'E0001DemoPostDataImport',
    component: () => import('./PgDataImport')

  }
]
